import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Input, Form,Row,Col,Slider, InputNumber,Divider,Button,message  } from 'antd';
import {layout, ExTable} from 'icsoc-antd-ex';
import UnionComponent from 'Components/union/unionComponent';
import tSoundMarket from 'Actions/systemSetting/soundMarket';
import iconMan from 'Static/images/market/img_nan@2x.png';
import iconWomen from 'Static/images/market/img_nv@2x.png';
import iconManChild from 'Static/images/market/img_ertongnan@2x.png';
import iconWomenChild from 'Static/images/market/img_ertongnv@2x.png';
import iconSelect from 'Static/images/market/icon_gou_selected@2x.png';
import './index.less';
const { BaseContentMainHeader } = layout;
const { TextArea } = Input;
class SoundMarket extends UnionComponent {
  constructor(props){
    super(props);
    this.state={
      tabList:[
        {name:'通用',value:1},
        {name:'客服',value:2},
        {name:'直播',value:3},
        {name:'童声',value:4},
        {name:'英文',value:5},
        {name:'方言',value:6},
        {name:'多语种',value:7}
      ],
      tabIndex:0,
      tabAll:[],
      tabSelectList:[],
      tabSelectActive:'',
      selectVal:{},
      speedValue: 0,
      intonationValue:0,
      volumeValue:50,
      textarerVal:'您好，我是您的语音机器人，很高兴为您服务，请问有什么可以帮您？',
      voiceUrl:''
    }
  }
  componentDidMount(){
    const {audio} = this;
    audio.addEventListener('error', this.onError, false);
    audio.addEventListener('ended', this.onEnded, false);
    this.getTabList();
  }
  componentWillUnmount(){
    const {audio}= this;
    audio.removeEventListener('error', this.onError);
    audio.removeEventListener('ended', this.onEnded);
  }
  getTabList(){
    const {actions}=this.props;
    actions.getMarketList().then(res=>{
      if(res.payload.code==200){
        this.setState({
          tabAll:res.payload.data,
          tabSelectList:res.payload.data['通用场景'],
          tabSelectActive:res.payload.data['通用场景'][0].value
        });
      }
    })
  }
  onError(){
    message.error("播放音频失败，请稍后重试！");
  }
  getUrl=(type)=>{
    const {actions}=this.props;
    const {tabSelectActive,speedValue,intonationValue,volumeValue,textarerVal}=this.state;
    if(speedValue>500 || speedValue<-500){
      return message.warning('语速请输入-500~500范围之间的数字！');
    }
    if(intonationValue>500 || intonationValue<-500){
      return message.warning('语调请输入-500~500范围之间的数字！');
    }
    if(volumeValue>100 || volumeValue<0){
      return message.warning('音量请输入0~100范围之间的数字！');
    }
    if(type=='play'){
       this.audio && this.audio.pause();
    }
    let params={
      txt:textarerVal,ttsVoiceName:tabSelectActive,ttsVolume:volumeValue,
      ttsSpeechRate:speedValue,ttsPitchRate:intonationValue
    }
    actions.getMarketUrl(params).then(res=>{
      if(res.payload.code==200){
        if(type=='play'){
          if(this.audio){
            this.audio.src=`${res.payload.data.voiceUrl}?time=${new Date().getTime()}`;
            this.audio.play();
          }
        }else if(type=='download'){
          window.open(res.payload.data.voiceUrl);
          // const downloadFileA=document.createElement('a');
          // downloadFileA.href=res.payload.data.voiceUrl;
          // downloadFileA.target='_blank';
          // downloadFileA.rel='noreferrer';
          // downloadFileA.click();
          // document.body.removeChild(downloadFileA);
        }
      }
    })
  }
  changeTab=(i,name)=>{
    const{tabAll,tabSelectList}=this.state;
    let keyName=name+'场景';
    this.setState({
      tabIndex:i,
      tabSelectList:tabAll[keyName],
      tabSelectActive:tabAll[keyName][0].value
    });
  }
  selectListVal=(item)=>{
    this.setState({
      selectVal:item,
      tabSelectActive:item.value
    })
  }
  onChangeSetting = (value,type) => {
    if (isNaN(value)) {
      return;
    }
    switch(type){
      case 'speed':
        this.setState({speedValue:value});
        break;
      case 'intonation':
        this.setState({intonationValue:value});
        break;
      case 'volume':
        this.setState({volumeValue:value});
        break;
    }
  };
  //文本输入
  changeTextareaVal=(e)=>{
    this.setState({textarerVal:e.target.value})
  }
  render(){
    const {tabList,tabIndex,tabSelectList,tabSelectActive,speedValue,intonationValue,volumeValue,textarerVal,voiceUrl } = this.state;
    return(
      <div className='soundMarket-wrap'>
        {/* 音频播放器 */}
        <audio ref={c => {this.audio = c;}}>
          Your browser does not support the audio element.
        </audio>
        <BaseContentMainHeader title="音色市场"></BaseContentMainHeader>
        <div className='soundMarket-wrap-container'>
          <div className='soundMarket-wrap-left'>
            <div className='soundMarket-wrap-title'>音色配置</div>
            <div className='soundMarket-wrap-left-content'>
              <div className='soundMarket-wrap-left-tab'>
                <span>适用场景：</span>
                {
                  tabList.map((item,i)=><span className={tabIndex==i ? 'soundMarket-wrap-tab-tag soundMarket-wrap-tab-active' : 'soundMarket-wrap-tab-tag'} 
                    key={item.name} onClick={()=>{this.changeTab(i,item.name)}}>{item.name}</span>)
                }
              </div>
              <div className='soundMarket-wrap-left-item-wrap'>
                {
                  tabSelectList && tabSelectList.map(item=>(
                    <div className={item.value==tabSelectActive ? 'soundMarket-wrap-left-item soundMarket-wrap-left-item-active' : 'soundMarket-wrap-left-item'} 
                      key={item.value} onClick={()=>{this.selectListVal(item)}}>
                      <div className='soundMarket-wrap-item-img'>
                        {item.icon=='icon-women' ? <img src={iconWomen} width='100%' /> : null}
                        {item.icon=='icon-man' ? <img src={iconMan} width='100%' /> : null}
                        {item.icon=='icon-women-child' ? <img src={iconWomenChild} width='100%' /> : null}
                        {item.icon=='icon-man-child' ? <img src={iconManChild} width='100%' /> : null}
                      </div>
                      <div className='soundMarket-wrap-item-text'>
                        <p>{item.name}</p>
                        <p>{item.type}</p>
                      </div>
                      {
                        item.value==tabSelectActive ?
                        <div className='soundMarket-wrap-item-select'><img src={iconSelect} width='100%' /></div>
                        : null
                      }
                    </div>  
                  ))
                }
              </div>
              <div className='soundMarket-wrap-left-bottom'>
                <div>参数设置：</div>
                <div className='soundMarket-wrap-left-speed'>
                  <Row>
                    <Col span={2} style={{lineHeight:'36px'}}>语速</Col>
                    <Col span={10}>
                      <Slider
                        min={-500}
                        max={500}
                        onChange={(e)=>this.onChangeSetting(e,'speed')}
                        value={typeof speedValue === 'number' ? speedValue : 0}
                        step={10}
                      />
                    </Col>
                    <Col span={10}>
                      <InputNumber
                        min={-500}
                        max={500}
                        style={{ margin: '0 16px',height:'36px' }}
                        step={10}
                        value={speedValue}
                        onChange={(e)=>this.onChangeSetting(e,'speed')}
                      />
                      <span>正常</span>
                      <span className='soundMarket-wrap-left-other'>(范围：-500~500)</span>
                    </Col>
                  </Row>
                  <Row className='soundMarket-wrap-left-intonation'>
                    <Col span={2} style={{lineHeight:'36px'}}>语调</Col>
                    <Col span={10}>
                    <Slider min={-500} max={500} onChange={(e)=>this.onChangeSetting(e,'intonation')} step={1}
                      value={typeof intonationValue === 'number' ? intonationValue : 0} />
                    </Col>
                    <Col span={10}>
                      <InputNumber min={-500} max={500} style={{ margin: '0 16px',height:'36px' }} step={1}
                        value={intonationValue}  onChange={(e)=>this.onChangeSetting(e,'intonation')} />
                      <span>正常</span>
                      <span className='soundMarket-wrap-left-other'>(范围：-500~500)</span>
                    </Col>
                  </Row>
                  <Row className='soundMarket-wrap-left-volume'>
                    <Col span={2} style={{lineHeight:'36px'}}>音量</Col>
                    <Col span={10}>
                    <Slider min={0} max={100} onChange={(e)=>this.onChangeSetting(e,'volume')} step={1}
                      value={typeof volumeValue === 'number' ? volumeValue : 50} />
                    </Col>
                    <Col span={10}>
                      <InputNumber min={0} max={100} style={{ margin: '0 16px',height:'36px' }} step={1}
                        value={volumeValue}  onChange={(e)=>this.onChangeSetting(e,'volume')} />
                      <span>正常</span>
                      <span className='soundMarket-wrap-left-other'>(范围：0~100)</span>
                    </Col>
                  </Row>
                  <Row className='soundMarket-wrap-left-format'>
                    <Col span={2} style={{lineHeight:'36px'}}>格式</Col>
                    <Col span={10}><span className='soundMarket-wrap-left-wav'>wav</span></Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
          <div className='soundMarket-wrap-right'>
            <div className='soundMarket-wrap-title'>示例文本</div>
            <div className='soundMarket-wrap-right-textarea-wrap'>
              <TextArea maxLength={270} className='soundMarket-wrap-right-textarea' value={textarerVal}
                onChange={this.changeTextareaVal} />
              <div className='soundMarket-wrap-right-text'>
                您还可以输入<span>270</span>个字
              </div>
            </div>
          </div>
        </div>
        <Divider />
        <div className='soundMarket-footer-wrap'>
          <Button type="primary" icon='play-circle' onClick={()=>this.getUrl('play')} style={{height:'40px'}}>播放语言</Button>
          <Button type="primary" icon="download" style={{marginLeft:'16px',height:'40px'}} onClick={()=>this.getUrl('download')}>下载到本地</Button>
        </div>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  login:state.login
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(tSoundMarket, dispatch),
});
export default connect(mapStateToProps,mapDispatchToProps)(SoundMarket);